<template>
  <div class="card m-2">
    <div class="card-body" v-if="mode != 'pdf'">
      <div class="card-title">
        {{ item.Title }}
      </div>
      <div class="card-text">
        <div class="row">
          <div class="col-6">
            {{ this.$t("message.find_partner.corporate_news_search_Id") }}:
          </div>
          <div class="col-6">{{ item.Id }}</div>
        </div>
        <div class="row">
          <div class="col-6">
            {{ this.$t("message.find_partner.corporate_news_search_NewsId") }}:
          </div>
          <div class="col-6">{{ item.NewsId }}</div>
        </div>
        <div class="row">
          <div class="col-6">
            {{ this.$t("message.find_partner.corporate_news_search_Source") }}:
          </div>
          <div class="col-6">{{ item.Source }}</div>
        </div>
        <div class="row">
          <div class="col-6">
            {{ this.$t("message.find_partner.corporate_news_search_Url") }}:
          </div>
          <div class="col-6">
            <a :href="item.Url" target="_blank">{{ item.Url }}</a>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            {{
              this.$t("message.find_partner.corporate_news_search_PublishTime")
            }}:
          </div>
          <div class="col-6">{{ item.PublishTime }}</div>
        </div>
        <div class="row">
          <div class="col-6">
            {{
              this.$t("message.find_partner.corporate_news_search_EmotionType")
            }}:
          </div>
          <div class="col-6">{{ item.EmotionType }}</div>
        </div>
        <div class="row">
          <div class="col-6">
            {{
              this.$t("message.find_partner.corporate_news_search_Category")
            }}:
          </div>
          <div class="col-6">{{ item.Category }}</div>
        </div>
        <div class="row">
          <div class="col-6">
            {{
              this.$t("message.find_partner.corporate_news_search_NewsTags")
            }}:
          </div>
          <div class="col-6">{{ item.NewsTags }}</div>
        </div>
        <div class="row">
          <div class="col-6">
            {{ this.$t("message.find_partner.corporate_news_search_Content") }}:
          </div>
          <div class="col-6">{{ item.Content }}</div>
        </div>
      </div>
    </div>
    <div class="card-body" v-if="mode == 'pdf'">
      <h4 class="card-title">
        {{ item.Title }}
      </h4>
      <table style="width: 100%">
        <tr class="row">
          <td class="col-6">
            {{ this.$t("message.find_partner.corporate_news_search_Id") }}:
          </td>
          <td class="col-6">{{ item.Id }}</td>
        </tr>
        <tr class="row">
          <td class="col-6">
            {{ this.$t("message.find_partner.corporate_news_search_NewsId") }}:
          </td>
          <td class="col-6">{{ item.NewsId }}</td>
        </tr>
        <tr class="row">
          <td class="col-6">
            {{ this.$t("message.find_partner.corporate_news_search_Source") }}:
          </td>
          <td class="col-6">{{ item.Source }}</td>
        </tr>
        <tr class="row">
          <td class="col-6">
            {{ this.$t("message.find_partner.corporate_news_search_Url") }}:
          </td>
          <td class="col-6">
            <a :href="item.Url" target="_blank">{{ item.Url }}</a>
          </td>
        </tr>
        <tr class="row">
          <td class="col-6">
            {{
              this.$t("message.find_partner.corporate_news_search_PublishTime")
            }}:
          </td>
          <td class="col-6">{{ item.PublishTime }}</td>
        </tr>
        <tr class="row">
          <td class="col-6">
            {{
              this.$t("message.find_partner.corporate_news_search_EmotionType")
            }}:
          </td>
          <td class="col-6">{{ item.EmotionType }}</td>
        </tr>
        <tr class="row">
          <td class="col-6">
            {{
              this.$t("message.find_partner.corporate_news_search_Category")
            }}:
          </td>
          <td class="col-6">{{ item.Category }}</td>
        </tr>
        <tr class="row">
          <td class="col-6">
            {{
              this.$t("message.find_partner.corporate_news_search_NewsTags")
            }}:
          </td>
          <td class="col-6">{{ item.NewsTags }}</td>
        </tr>
        <tr class="row">
          <td class="col-6">
            {{ this.$t("message.find_partner.corporate_news_search_Content") }}:
          </td>
          <td class="col-6">{{ item.Content }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: "corporate-news-item",
  props: ["item", "mode"],
};
</script>
